module.exports = __webpack_public_path__ + "static/media/abzug_lampe_aus.c9dcfc2e.jpg";